import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_4 = { class: "flex items-center gap-2" }
const _hoisted_5 = { class: "text-sm text-gray-500" }
const _hoisted_6 = { class: "divide-y divide-gray-100 border-t border-gray-200" }
const _hoisted_7 = { class: "col-span-3" }
const _hoisted_8 = { class: "font-medium text-gray-800 text-sm" }
const _hoisted_9 = { class: "col-span-2 text-center text-sm" }
const _hoisted_10 = { class: "text-blue-600 font-medium" }
const _hoisted_11 = { class: "text-blue-600 font-medium" }
const _hoisted_12 = { class: "text-xs text-gray-400" }
const _hoisted_13 = {
  key: 2,
  class: "text-xs text-gray-400 italic"
}
const _hoisted_14 = { class: "col-span-3 text-center" }
const _hoisted_15 = { class: "text-base font-semibold text-gray-700" }
const _hoisted_16 = { class: "text-base font-semibold text-gray-700" }
const _hoisted_17 = { class: "text-sm text-gray-500" }
const _hoisted_18 = {
  key: 2,
  class: "text-gray-300 text-sm italic"
}
const _hoisted_19 = { class: "col-span-3" }
const _hoisted_20 = {
  key: 0,
  class: "grid grid-cols-2 gap-1"
}
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = {
  key: 1,
  class: "flex gap-1 items-center"
}
const _hoisted_24 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = ["value"]
const _hoisted_27 = {
  key: 1,
  class: "text-xs text-gray-400 shrink-0"
}

import { useEnvAttrsModifier } from "@/composables/tasks/environmental-modifier/useEnvAttrsModifier";
import FooterActions from "@/components/v2/Tasks/Vaccination/Buttons/ActionButtons/FooterActions.vue";
import { ref, watch } from 'vue';
import { TasksService } from "@/services/v2/tasks";
import { useTask } from "@/composables/tasks/useTask";
import { TaskTankAttribute } from "@/types/v2";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { activeTask } = useTask();
const { tanks } = useEnvAttrsModifier();

// ── Expand / collapse ────────────────────────────────────────────────────────
const expandedIndices = ref<number[]>([]);

watch(tanks, (loadedTanks) => {
  if (loadedTanks.length && !expandedIndices.value.length) {
    expandedIndices.value = loadedTanks.map((_, i) => i);
    initEnteredValues();
  }
}, { immediate: true });

const toggleTank = (index: number) => {
  const pos = expandedIndices.value.indexOf(index);
  pos !== -1 ? expandedIndices.value.splice(pos, 1) : expandedIndices.value.push(index);
};
const isTankExpanded = (index: number) => expandedIndices.value.includes(index);

// ── Seed enteredValue on each attribute once tanks load ──────────────────────
const initEnteredValues = () => {
  for (const tank of tanks.value) {
    for (const attr of tank.attributes ?? []) {
      if (attr.enteredValue) continue;
      if (attr.name === 'light_regime') {
        attr.enteredValue = {
          light: attr.previousValue?.light ?? attr.target?.light ?? null,
          dark:  attr.previousValue?.dark  ?? attr.target?.dark  ?? null,
        };
      } else {
        attr.enteredValue = {
          value: attr.previousValue?.value ?? null,
          unit:  attr.previousValue?.unit ?? attr.unit ?? attr.units?.[0] ?? undefined,
        };
      }
    }
  }
};

// ── Helpers ──────────────────────────────────────────────────────────────────
const isLightRegime    = (attr: TaskTankAttribute) => attr.name === 'light_regime';
const hasRangeTarget   = (attr: TaskTankAttribute) =>
  !isLightRegime(attr) && attr.target != null && attr.target.min !== undefined;
const hasMultipleUnits = (attr: TaskTankAttribute) => (attr.units?.length ?? 0) > 1;

// ── Finish ───────────────────────────────────────────────────────────────────
const handleComplete = async () => {
  if (!activeTask.value) return;
  await TasksService.finishTask(activeTask.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "text-lg font-semibold text-gray-900" }, "Tank-Environmental Attributes Modifier", -1)),
      _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-sm text-gray-500" }, "Review the previous values and enter the new ones for each attribute.", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tanks), (tank, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: tank.key,
          class: "my-4 bg-gray-50 rounded-sm shadow-md ring-1 ring-gray-200 overflow-hidden"
        }, [
          _createElementVNode("div", {
            onClick: ($event: any) => (toggleTank(index)),
            class: "p-4 cursor-pointer flex justify-between items-center hover:bg-gray-100 transition-colors"
          }, [
            _createElementVNode("h3", _hoisted_3, _toDisplayString(tank.label), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(tank.attributes?.length) + " attributes", 1),
              (_openBlock(), _createElementBlock("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: _normalizeClass(["h-5 w-5 text-gray-500 transition-transform", { 'rotate-180': !isTankExpanded(index) }]),
                viewBox: "0 0 20 20",
                fill: "currentColor"
              }, _cache[0] || (_cache[0] = [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                  "clip-rule": "evenodd"
                }, null, -1)
              ]), 2))
            ])
          ], 8, _hoisted_2),
          _withDirectives(_createElementVNode("div", _hoisted_6, [
            _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"grid grid-cols-12 gap-2 px-4 py-2 bg-gray-100 text-xs font-semibold text-gray-500 uppercase tracking-wide\"><div class=\"col-span-3\">Attribute</div><div class=\"col-span-2 text-center\">Target</div><div class=\"col-span-3 text-center\">Old value</div><div class=\"col-span-1 text-center\"></div><div class=\"col-span-3 text-center\">New value</div></div>", 1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tank.attributes, (attr) => {
              return (_openBlock(), _createElementBlock("div", {
                key: attr.attributeId,
                class: "grid grid-cols-12 gap-2 items-center px-4 py-4 bg-white hover:bg-gray-50"
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(attr.label), 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(["inline-block mt-1 text-xs font-medium px-2 py-0.5 rounded-full", attr.intent === 'adjust' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-500'])
                  }, _toDisplayString(attr.intent === 'adjust' ? 'Adjust' : 'Record'), 3)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  (isLightRegime(attr) && attr.target)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(attr.target.light) + "h / " + _toDisplayString(attr.target.dark) + "h", 1),
                        _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-xs text-gray-400" }, "light / dark", -1))
                      ], 64))
                    : (attr.target)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("span", _hoisted_11, _toDisplayString(attr.target.min) + " – " + _toDisplayString(attr.target.max), 1),
                          _createElementVNode("p", _hoisted_12, _toDisplayString(attr.target.unit ?? attr.unit), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock("span", _hoisted_13, "Value Change"))
                ]),
                _createElementVNode("div", _hoisted_14, [
                  (isLightRegime(attr) && attr.previousValue)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(attr.previousValue.light) + "h / " + _toDisplayString(attr.previousValue.dark) + "h", 1),
                        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-xs text-gray-400" }, "light / dark", -1))
                      ], 64))
                    : (attr.previousValue && attr.previousValue.value !== undefined)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("span", _hoisted_16, _toDisplayString(attr.previousValue.value), 1),
                          _createElementVNode("span", _hoisted_17, _toDisplayString(attr.previousValue.unit), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock("span", _hoisted_18, "No history"))
                ]),
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col-span-1 flex justify-center" }, [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: "h-5 w-5 text-gray-400",
                    viewBox: "0 0 20 20",
                    fill: "currentColor"
                  }, [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      d: "M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z",
                      "clip-rule": "evenodd"
                    })
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_19, [
                  (isLightRegime(attr))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("div", null, [
                          _cache[3] || (_cache[3] = _createElementVNode("label", { class: "block text-xs text-gray-400 mb-1" }, "Light (h)", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            min: "0",
                            max: "24",
                            "onUpdate:modelValue": ($event: any) => ((attr.enteredValue!.light) = $event),
                            class: "w-full border border-gray-300 rounded px-2 py-1.5 text-sm font-semibold text-primary focus:outline-none focus:border-primary"
                          }, null, 8, _hoisted_21), [
                            [
                              _vModelText,
                              attr.enteredValue!.light,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[4] || (_cache[4] = _createElementVNode("label", { class: "block text-xs text-gray-400 mb-1" }, "Dark (h)", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            min: "0",
                            max: "24",
                            "onUpdate:modelValue": ($event: any) => ((attr.enteredValue!.dark) = $event),
                            class: "w-full border border-gray-300 rounded px-2 py-1.5 text-sm font-semibold text-primary focus:outline-none focus:border-primary"
                          }, null, 8, _hoisted_22), [
                            [
                              _vModelText,
                              attr.enteredValue!.dark,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          "onUpdate:modelValue": ($event: any) => ((attr.enteredValue!.value) = $event),
                          placeholder: hasRangeTarget(attr) ? `${attr.target!.min}–${attr.target!.max}` : '',
                          class: "flex-1 min-w-0 border border-gray-300 rounded px-2 py-1.5 text-sm font-semibold text-primary focus:outline-none focus:border-primary"
                        }, null, 8, _hoisted_24), [
                          [
                            _vModelText,
                            attr.enteredValue!.value,
                            void 0,
                            { number: true }
                          ]
                        ]),
                        (hasMultipleUnits(attr))
                          ? _withDirectives((_openBlock(), _createElementBlock("select", {
                              key: 0,
                              "onUpdate:modelValue": ($event: any) => ((attr.enteredValue!.unit) = $event),
                              class: "border border-gray-300 rounded px-2 py-1.5 text-xs bg-white focus:outline-none focus:border-primary"
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attr.units, (u) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: u,
                                  value: u
                                }, _toDisplayString(u), 9, _hoisted_26))
                              }), 128))
                            ], 8, _hoisted_25)), [
                              [_vModelSelect, attr.enteredValue!.unit]
                            ])
                          : (attr.unit)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(attr.unit), 1))
                            : _createCommentVNode("", true)
                      ]))
                ])
              ]))
            }), 128))
          ], 512), [
            [_vShow, isTankExpanded(index)]
          ])
        ]))
      }), 128))
    ]),
    _createVNode(FooterActions, null, {
      start: _withCtx(() => _cache[9] || (_cache[9] = [
        _createElementVNode("button", {
          onClick: () => {},
          class: "w-full"
        }, "Instructions", -1)
      ])),
      end: _withCtx(() => [
        _createElementVNode("button", {
          onClick: handleComplete,
          class: "w-full"
        }, "Finish task")
      ]),
      _: 1
    })
  ], 64))
}
}

})